module.exports = __webpack_public_path__ + "static/media/DuplicateSans-Medium.f458c25e.woff";